
export interface Visio2Stream extends Emitter {
    getVideo(): Promise<HTMLMediaElement>
    destroy(): void
    setPreferredResolution(options: { width: Number, height: Number }): void
    isLocal(): Boolean
    isVideoDisabled(): Boolean
    isAudioDisabled(): Boolean
}

export interface Visio2Api {
    connect(roomUid: String, streamUid: String, key?: String): Promise<Visio2Room>
}

export enum Visio2ConnectionState {
    Disconnected = 'Disconnected',
    Connecting = 'Connecting',
    Connected = 'Connected',
    Error = 'Error'
}

export interface Visio2Room extends Emitter {


    state: Visio2ConnectionState
    publish(streamUid: String, config: DeviceConfig)
    getStream(streamUid: String): Promise<Visio2Stream>
}

export interface Visio2Publisher extends Emitter {
    getVideoElement(): HTMLVideoElement
    publishAudio(state: Boolean): void
    publishVideo(state: Boolean): void
    getAudioDeviceId(): String
    getVideoDeviceId(): String
    audioSourceEnabled(): Boolean
    videoSourceEnabled(): Boolean
    destroy(): void
}

/**
 * @fires 
 */
export interface Visio2Subscriber {
    getVideoElement(): HTMLVideoElement
}
export interface Visio2Subsriber {
    getVideoElement(): HTMLVideoElement
}
export interface DeviceConfig {
    videoInputDevice: String | MediaStreamTrack;
    videoInputDeviceEnabled: Boolean;
    audioInputDevice: String | MediaStreamTrack;
    audioInputDeviceEnabled: Boolean;
    // audiooutput: String

    // ***************************
    // *** audio configuration ***
    enableStereo?: Boolean

    // disable all audio processing
    disableAudioProcessing?: Boolean
    // default audio processing
    echoCancellation?: Boolean
    autoGainControl?: Boolean
    noiseSuppression?: Boolean

    // ***************************
    // *** video configuration ***
    scalableVideo?: Boolean,
    resolution?: String,
    videoContentHint?: String,

}



import { Emittery } from '/vodalys/.jslibs'

export abstract class Emitter {
    emitter = new Emittery<{ open: String, close: undefined }>()

    on(eventName: String | [String], listener: Function) {
        return this.emitter.on(eventName, listener)
    }

    off(eventName: String | [String], listener: Function) {
        return this.emitter.off(eventName, listener)
    }

    once(eventName: String | [String]) {
        return this.emitter.once(eventName)
    }

    emit(eventName: String, data?) {
        return this.emitter.emit(eventName, data)
    }

    onAny(listener: Function) {
        return this.emitter.onAny(listener)
    }
    offAny(listener: Function) {
        return this.emitter.offAny(listener)
    }
    clearListeners(eventNames?) {
        return this.emitter.clearListeners(eventNames)
    }
}